'use client'

import { sidebarLocalStorageKeys } from '~/lib/dom-keys'
import { ResizableContainer } from '~/sotano-kit/primitives/resizable-container'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { useUserStore } from '~/app/_store/user-store'
import { useUserPreferences } from '~/hooks-data/use-user-preferences'
import { useStorage } from '~/hooks/use-storage'

type DocumentResizableContainerProps = {
  children?: React.ReactNode
}

export function DocumentResizableContainer({
  children,
}: DocumentResizableContainerProps) {
  const collapseDocumentPanel = useUserPreferences(
    (s) => s.collapseDocumentPanel
  )
  const { data: repoReplicacheData } = useRepoReplicache()
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  return (
    <ResizableContainer
      sizeToClose={150}
      sizeToOpen={150}
      minWidth={232}
      maxWidth={400}
      defaultWidth={250}
      direction="right"
      className="flex h-screen w-full flex-col overflow-auto bg-dark-bg"
      widthLocalStorageKey={sidebarLocalStorageKeys.repoSideBarWidth}
      noBorderHighlight
      isClosed={collapseDocumentPanel === true}
      setIsClosed={async (isToggled: boolean) => {
        if (!repoReplicacheData?.replicache || !optimisticUser) return
        await repoReplicacheData.replicache.mutate.setCollapsedDocumentPanel({
          userId: optimisticUser.id,
          isCollapsed: isToggled,
        })
      }}
    >
      {children}
    </ResizableContainer>
  )
}

export function DocumentResizableContainer__PUBLIC({
  children,
}: DocumentResizableContainerProps) {
  const [isClosed, setIsClosed] = useStorage(
    'localStorage',
    (z) => z.boolean(),
    'document-resizable-container-is-closed-public',
    { initialValue: false }
  )

  return (
    <ResizableContainer
      minWidth={232}
      maxWidth={400}
      defaultWidth={250}
      direction="right"
      className="flex h-screen w-full flex-col overflow-auto bg-dark-bg"
      widthLocalStorageKey={sidebarLocalStorageKeys.repoSideBarWidth}
      isClosed={isClosed}
      setIsClosed={setIsClosed}
      noBorderHighlight
    >
      {children}
    </ResizableContainer>
  )
}
